
cc.Class({
    extends: cc.Component,

    properties: {
        isScalable: true,
        scaleTime: 0.05,
        scaleValue: 0.85
    },

    onLoad () {
        this.button = this.node.getComponent(cc.Button);

        if (!this.button) {
            cc.warn(`UpgradeUIButton: There is no button component on '${this.node.name}' node`);
        }

        const eventHandler = new cc.Component.EventHandler();

        eventHandler.target = this.node;
        eventHandler.component = 'UpgradeUIButton';
        eventHandler.handler = 'onClick';

        this.button.clickEvents.push(eventHandler);

        this.node.on(cc.Node.EventType.MOUSE_DOWN, this._onMouseDown.bind(this), this);
        this.node.on(cc.Node.EventType.MOUSE_UP, this._onMouseUp.bind(this), this);
        this.node.on(cc.Node.EventType.MOUSE_LEAVE, this._onMouseUp.bind(this), this);

        this.origin = { scaleX: this.node.scaleX, scaleY: this.node.scaleY };
        this.target = this.button.target;
        this.isMouseDown = false;
    },

    onClick () {
        this._onMouseDown();
    },

    _onMouseDown () {
        if (!this.button.interactable) {
            return;
        }

        this.isMouseDown = true;

        if (this.isScalable) {
            //reset
            this.target.stopAllActions();
            this.target.setScale(this.origin.scaleX, this.origin.scaleY);
            // run action
            this.target.runAction(cc.sequence(
                cc.scaleTo(this.scaleTime, this.origin.scaleX * this.scaleValue , this.origin.scaleY * this.scaleValue),
                cc.callFunc(() => {})
            ));
        }
    },

    _onMouseUp () {
        if (this.isScalable && this.isMouseDown) {
            //reset
            this.target.stopAllActions();
            // this.node.setScale(this.origin.scaleX * this.scaleValue, this.origin.scaleY * this.scaleValue);
            // run action
            this.target.runAction(cc.sequence(
                cc.scaleTo(this.scaleTime, this.origin.scaleX, this.origin.scaleY),
                cc.callFunc(() => {})
            ));
        }
        this.isMouseDown = false;
    }
});
